import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const drugsIllicit: AnswerPathTreeNode = { path: 'drugsIllicit', nodeId: NodeIds.drugsIllicit };
